import { Component, Inject } from '@angular/core';
import { MyErrorStateMatcher } from 'src/app/utils/errorStateMatcher';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EquipmentAir } from 'src/app/model/equipment';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentTypeService } from 'src/app/services/equipmentType.service';
import { EquipmentType } from 'src/app/model/equipmentType';

export interface DialogDataEquipment {
  equipment: EquipmentAir;
  isEdit: boolean;
}

@Component({
    selector: 'app-protocol-edit-dialog-equipment',
    templateUrl: 'protocol-edit-dialog-equipment.component.html',
    standalone: false,
})
export class ProtocolEditEquipmentDialogComponent {

  matcher = new MyErrorStateMatcher();
  tituloDialog: string;
  form: UntypedFormGroup;

  equipmentTypes: EquipmentType[];

  constructor(
    fb: UntypedFormBuilder,
    private equipmentTypeService: EquipmentTypeService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<ProtocolEditEquipmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataEquipment) {
    if (data.isEdit) {
      this.tituloDialog = this.translate.instant('protocolEdit.dialog.equipment.title.edit', { name: data.equipment.idType }) as string;
    } else {
      this.tituloDialog = this.translate.instant('protocolEdit.dialog.equipment.title.create') as string;
    }

    this.form = fb.group({
      idType: [this.data.equipment.idType, [Validators.required]],
      equipment: [this.data.equipment],
      maker: [this.data.equipment.maker],
      model: [this.data.equipment.model],
      serialNum: [this.data.equipment.serialNum]
    });

    this.equipmentTypeService.findAll().subscribe((res: EquipmentType[]) => {
      this.equipmentTypes = res;

      if (this.data.equipment.idType == null) {
        this.data.equipment.idType = 1;
      }
    });
  }

  onOkClick(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.data.equipment);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
